import { useExperimentTakeover } from 'modules/experiments/takeover';
import { useTemplateTakeover } from 'modules/templateEditor/integrations/InStudioTemplateEditing/context/TemplateTakeoverContext';
import { PaddedFormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';
import { Dispatch, SetStateAction } from 'react';
import { SecondaryButton } from 'ui/button';
import { useFeatureFlags } from '../../BaseSendEditor.hooks';
import { TEMPLATE_PREVIEW_AURORA_ID, displayContent } from './TemplatePreview.constants';
import { EmptyPreviewContainer } from './TemplatePreview.styled';
import { TemplatePreviewAurora, TemplatePreviewAuroraProps } from './TemplatePreviewAurora';
import {
  TemplatePreviewNonAurora,
  TemplatePreviewNonAuroraProps,
} from './TemplatePreviewNonAurora';

export interface TemplatePreviewProps
  extends Omit<TemplatePreviewAuroraProps & TemplatePreviewNonAuroraProps, 'templateId'> {
  templateId?: number;
  isDisabled?: boolean;
  currentLocale?: string;
  setCurrentLocale: Dispatch<SetStateAction<string | undefined>>;
}

export const TemplatePreview = (props: TemplatePreviewProps) => {
  const { studioTemplateEditingIsEnabled } = useFeatureFlags();
  const takeover = useTemplateTakeover();
  const { isExperimentTakeoverOpen } = useExperimentTakeover();

  if (takeover.isOpen || isExperimentTakeoverOpen) return null;

  const { templateId, isDisabled = false } = props;
  const hasTemplate = !!templateId;
  const PreviewCmp = studioTemplateEditingIsEnabled
    ? TemplatePreviewAurora
    : TemplatePreviewNonAurora;

  return (
    <PaddedFormSectionContent
      data-test={studioTemplateEditingIsEnabled && TEMPLATE_PREVIEW_AURORA_ID}
    >
      {!hasTemplate ? (
        <EmptyPreviewContainer>
          <SecondaryButton onClick={() => !isDisabled && takeover.open()} isDisabled={isDisabled}>
            {displayContent.chooseText}
          </SecondaryButton>
          {displayContent.emptyText}
        </EmptyPreviewContainer>
      ) : (
        <PreviewCmp
          {...props}
          templateId={templateId}
          onAttachClick={() => takeover.open()}
          onStateUpdate={(state) => takeover.set(state)}
          onViewChange={takeover.setView}
        />
      )}
    </PaddedFormSectionContent>
  );
};

export default TemplatePreview;
